import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'

import { INewUser } from '../../../../types/user'
import { createUser } from '../../../../store/users/actions'
import { Create } from './Create'
import { ICreateDispatchProps, ICreateStateProps } from './types'
import { IState } from '../../../../store/types'
import { fetchInstallations } from '../../../../store/installations/actions'

const mapStateToProps = (state: IState): ICreateStateProps => {
  return {
    installations: state.installations
  }
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, AnyAction>): ICreateDispatchProps => {
  return {
    fetchInstallations: () => {
      return dispatch(fetchInstallations())
    },

    createUser: (user: INewUser) => {
      return dispatch(createUser(user))
    }
  }
}

const CreateContainer = connect(mapStateToProps, mapDispatchToProps)(Create)

export {
  CreateContainer
}
